import OLpGlobalFooter from './index.vue';

OLpGlobalFooter.install = app => {
  app.component(OLpGlobalFooter.name, OLpGlobalFooter);
};

export default OLpGlobalFooter;
